import { libraryObjects as pvLibraryObjects } from './pv'
import { libraryObjects as ledLibraryObjects } from './led'
import { libraryObjects as industryConsumptionLibraryObjects } from './industryConsumption'

export default { pv: pvLibraryObjects, led: ledLibraryObjects, industryConsumption: industryConsumptionLibraryObjects }
